module.exports = __webpack_public_path__ + "static/media/tete-leo.fec986a2.png";